import type { ReactNode } from "react";

type CardItemProps = {
  children: ReactNode
}

export const CardItem = ({ children }: CardItemProps) => (
  <div className="flex bg-neutral-op-8 rounded-md overflow-hidden min-h-[84px]">
    <div className="w-[4px] bg-[#2b88d8] shrink-0" />
    <div className="flex-1 p-4 grid grid-cols-1 md:grid-cols-3 gap-6 items-start">{children}</div>
  </div>
)

